import {
    SimpleForm,
    TextInput,
} from '@/components/admin';
import { Button } from '@/components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog';
import { email, required, useDataProvider, useNotify } from 'ra-core';

const validateRecipientEmail = [required(), email()];

export interface DocumentEmailSenderProps {
    open: boolean;
    onClose: () => void;
    record: any;
    resource: string;
}

export const DocumentEmailSender = ({ open, onClose, record, resource }: DocumentEmailSenderProps) => {
    const notify = useNotify();
    const dataProvider = useDataProvider();

    const handleSend = async (data: any) => {
        try {
            if (typeof (dataProvider as any).sendEmail === 'function') {
                await (dataProvider as any).sendEmail(resource, {
                    id: record.id,
                    email: data.email,
                    subject: data.subject,
                    message: data.message,
                    category: 'customer',
                });
                notify('Email sent successfully', { type: 'success' });
            } else {
                notify('Email transport not configured', { type: 'error' });
                return;
            }
            onClose();
        } catch (error) {
            notify(
                `Error sending email: ${(error as Error).message}`,
                { type: 'error' },
            );
        }
    };

    if (!record) return null;

    const defaultSubject = `${resource.toUpperCase()} ${record.reference} from GSW ERP`;

    return (
        <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onClose()}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <DialogTitle>Send Document via Email</DialogTitle>
                </DialogHeader>
                
                <SimpleForm 
                    onSubmit={handleSend} 
                    defaultValues={{ 
                        email: record.customer_email || record.email || '',
                        subject: defaultSubject,
                        message: `Please find attached ${resource.toLowerCase()} ${record.reference}.`
                    }}
                    toolbar={
                        <div className="flex justify-end gap-2 mt-4">
                            <Button type="button" variant="outline" onClick={onClose}>Cancel</Button>
                            <Button type="submit">Send</Button>
                        </div>
                    }
                >
                    <div className="flex flex-col gap-4 w-full">
                        <TextInput source="email" label="Recipient Email" validate={validateRecipientEmail} className="w-full" />
                        <TextInput source="subject" label="Subject" className="w-full" />
                        <TextInput source="message" label="Message" multiline rows={4} className="w-full" />
                    </div>
                </SimpleForm>
            </DialogContent>
        </Dialog>
    );
};
